/**
 * ⚠️ The fallback is MODE-DEPENDENT on purpose.
 *
 * Hub shipped a production build with no API base once, so the bundle baked in
 * `localhost:8000`. Every user's browser then posted to their OWN machine: the
 * requests never left the laptop, so the server logs stayed clean and the outage
 * was invisible from the server side. In production the answer must be the
 * same-origin nginx proxy, never a developer's localhost.
 */
export const API_BASE: string =
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  (import.meta.env.PROD ? "/api" : "http://localhost:8010");

export const WS_BASE: string =
  (import.meta.env.VITE_WS_BASE as string | undefined) ??
  (import.meta.env.PROD
    ? `${location.protocol === "https:" ? "wss:" : "ws:"}//${location.host}/ws`
    : "ws://localhost:8010/ws");

export const PUBLIC_ORIGIN: string =
  (import.meta.env.VITE_PUBLIC_ORIGIN as string | undefined) ??
  (typeof window !== "undefined" ? window.location.origin : "");
